import { createSelector } from 'reselect'

const getMyLibraryPreview = state => state.myLibraryPreview

const myLibraryPreviewSelector = createSelector(
	[getMyLibraryPreview],
	myLibraryPreview => ({
		id: myLibraryPreview.id,
	})
)

export default myLibraryPreviewSelector
